import { render, staticRenderFns } from "./RedeemedCouponCustomersTable.vue?vue&type=template&id=414880bf&scoped=true&"
import script from "./RedeemedCouponCustomersTable.vue?vue&type=script&lang=babel&"
export * from "./RedeemedCouponCustomersTable.vue?vue&type=script&lang=babel&"
import style0 from "./RedeemedCouponCustomersTable.vue?vue&type=style&index=0&id=414880bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414880bf",
  null
  
)

export default component.exports